import Swiper from 'swiper/dist/js/swiper';
import $ from 'jquery';

import breakpoints from '../helpers/breakpoints';
import ShowIcon from './ShowIcon';

export default class {
  constructor($c) {
    const container = $c.find('.js-services-container');
    const prev = $c.find('.js-services-prev');
    const next = $c.find('.js-services-next');

    this.swiper = new Swiper(container, {
      navigation: { prevEl: prev, nextEl: next },
      loop: true,
      slidesPerView: 3,
      spaceBetween: 78,
      allowSlidePrev: false,
      allowSlideNext: false,
      breakpoints: {
        [breakpoints.mobile]: {
          allowSlidePrev: true,
          allowSlideNext: true,
          slidesPerView: 1
        }
      }
    });

    this.swiper.on('slideChange', () => {
      const $currentSlide = $(this.swiper.slides[this.swiper.activeIndex]);
      const $trigger = $currentSlide.find('.js-show-icon-trigger');

      ShowIcon.toggleIcon($trigger, true);
    });
  }
}
